import { SERVICE } from '@src/constants';
import api from './api';

export const statApps = async (organizationId, params) => {
  const res = await api({
    method: 'GET',
    url: `/organizations/${organizationId}/stats/stat-apps`,
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};

export const appRevenueStats = async (organizationId, params) => {
  const res = await api({
    method: 'GET',
    url: `/organizations/${organizationId}/reports`,
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};

export const packageQuantityStats = async (organizationId, params) => {
  const res = await api({
    method: 'GET',
    url: `/organizations/${organizationId}/reports/packages-quantity`,
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};

export const packageRevenueStats = async (organizationId, params) => {
  const res = await api({
    method: 'GET',
    url: `/organizations/${organizationId}/reports/packages-revenue`,
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};
